import { TENANT } from './tenant'

// The active tenant selects the CSS overlay. Set on <html> before React renders
// — and, critically, before theme.ts reads the CSS custom properties at module
// load — so charts and inline styles pick up the right accent with no flash.
// '' or 'solvigo' = the Solvigo default (Steel Blue / Signal Orange, no overlay).
const theme = TENANT.theme
if (theme && theme !== 'solvigo') {
  document.documentElement.dataset.theme = theme
} else {
  delete document.documentElement.dataset.theme
}

// Browser-tab title — kept short ("Insight"). The in-app wordmark stays the
// tenant logo (MINPRILLA) in the sidebar.
document.title = 'Insight'
